import PrivateLayoutContent from 'layouts/PrivateLayout'
import PublicLayout from 'layouts/PublicLayout'
import VolunteerLayout from 'layouts/VolunteerLayout'
import { observer } from 'mobx-react'
import StaticModeRegistrationPage from 'pages/Branch/EventManagement/VolunteerRegistration/StaticModeRegistrationPage'
import VolunteerNotFound from 'pages/Error/Volunteer404'
import { ConfirmDialog } from 'primereact/confirmdialog'
import { Route, Routes } from 'react-router-dom'
import { publicRoutes } from 'routers/routes'
import { STATIC_MODE_SEGMENT } from 'utils/helper/static-mode-route'

function App() {
  return (
    <>
      <Routes>
        <Route
          path={`${STATIC_MODE_SEGMENT}/404`}
          element={
            <VolunteerLayout>
              <VolunteerNotFound />
            </VolunteerLayout>
          }
        />
        <Route
          path={`:branchId/${STATIC_MODE_SEGMENT}/404`}
          element={
            <VolunteerLayout>
              <VolunteerNotFound />
            </VolunteerLayout>
          }
        />
        <Route
          path={`${STATIC_MODE_SEGMENT}/event-management/:eventId/registration`}
          element={
            <VolunteerLayout>
              <StaticModeRegistrationPage />
            </VolunteerLayout>
          }
        />
        {publicRoutes.map((route) => (
          <Route
            key={route.key}
            path={route.path}
            element={<PublicLayout>{route.element}</PublicLayout>}
          ></Route>
        ))}
        <Route
          path={'/*'}
          element={<PrivateLayoutContent></PrivateLayoutContent>}
        ></Route>
      </Routes>
      <ConfirmDialog />
    </>
  )
}

export default observer(App)
